<template>
	<AdminPageLayout :loading="loading" :error="error">
		<table class="generic-table">
				<thead>
					<tr>
						<th>Email</th>
						<th>Created</th>
						<th>Approved</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="invitation in invitations" :key="invitation.token">
						<td>{{ invitation.email }}</td>
						<td>{{ $formatDate(invitation.created) }}</td>
						<td>{{ $formatDate(invitation.approved) }}</td>
						<td>
							<div class="generic-table-actions">
								<button 
									@click="approveInvitation(invitation.token)"
									class="generic-table-action-button"
									:disabled="action_loading || invitation.approved"
								>
									Approve
								</button>
								<button 
									@click="deleteInvitation(invitation.token)"
									class="generic-table-action-button"
									:disabled="action_loading"
								>
									Delete
								</button>
							</div>
						</td>
					</tr>
				</tbody>
		</table>
	</AdminPageLayout>
</template>

<script>
import AdminPageLayout from './_PageLayout.vue'

export default {
	name: 'Approve',
	components: {
		AdminPageLayout
	},
	data() {
		return {
			loading: true,
			action_loading: false,
			error: '',
			invitations: []
		}
	},
	async mounted() {
		await this.fetchInvitations()
	},
	methods: {
		async fetchInvitations() {
			this.loading = true
			this.error = ''

			const authToken = localStorage.getItem('authToken')?.trim()
			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}
			
			try {
				const response = await this.$api.post('/api/admin/invitations', {
					authToken: authToken
				})
				
				this.invitations = response.data.invitations || []
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading invitations.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		},
		async approveInvitation(token) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/invitations/approve', {
					authToken: authToken,
					invitationToken: token
				})
				await this.fetchInvitations()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'Invitation not found.'
				} else {
					this.error = error
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		},
		async deleteInvitation(token) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/invitations/delete', {
					authToken: authToken,
					invitationToken: token
				})
				await this.fetchInvitations()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'Invitation not found.'
				} else {
					this.error = error
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		}
	}
}
</script>

<style scoped>
</style>

